export default {"src":"/_next/static/media/heart-outline-black.2302065d.svg","height":12,"width":13,"blurWidth":0,"blurHeight":0};